import { Alert, AlertIcon, Button, Container, Stack, Text } from '@chakra-ui/react';
import { useError, useSuccess } from '@pelicargo/ui';
import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import { Page } from '../../components/Page';
import { trpc } from '../../config/trpc';

export const Unsubscribe = () => {
  const { requestId, contactId } = useParams();
  const { handleSuccess } = useSuccess();
  const { handleError } = useError();

  const { mutate: unsubscribe } = trpc.unsubscribe.useMutation();
  const { mutateAsync: subscribe } = trpc.subscribe.useMutation();

  useEffect(() => {
    unsubscribe({ contact_id: contactId, request_id: requestId });
  }, [requestId, contactId, unsubscribe]);

  const handleResubscribe = async () => {
    try {
      await subscribe({
        contact_id: contactId,
        request_id: requestId,
      });
      handleSuccess('You are subscribed again.');
    } catch (error) {
      handleError('Something went wrong');
    }
  };

  return (
    <Page title="Unsubscribe" flex="1">
      <Container maxW="container.md" p="8" justifyContent="center" alignItems="center" h="80vh">
        <Stack justify="center" h="full" w="full" spacing="6">
          <Alert status="success" justifyContent="center">
            <AlertIcon />
            Unsubscribed Successfully
          </Alert>
          <Text>
            You have unsubscribed from this shipment and will not receive any further emails specific to this shipment.
          </Text>
          <Text>Didn't mean to unsubscribe? Click the button below to resubscribe!</Text>
          <Stack direction="row" align="center" w="full">
            <Button w="full" as={Link} to="/" aria-label="Home">
              Home
            </Button>
            <Button w="full" colorScheme="primary" onClick={handleResubscribe}>
              Resubscribe
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Page>
  );
};
